import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        alignSelf: 'stretch'
    },
    header: {
        position: 'absolute',
        top: 0
    },
    previewImage: {
        alignSelf: 'stretch',
        width: '100%',
        height: '100%',
        backgroundColor: Theme.primaryBackgroundColor,
        alignItems: 'center',
        justifyContent: 'center'
    },
    buttonsContainer: {
        flexDirection: 'column',
        height: '32%',
        maxHeight: Theme.BU * 8,
        justifyContent: 'space-between',
        width: '50%',
        maxWidth: Theme.BU * 25
    }
};

export default StyleSheet.create(baseStyles);
